import React, { useState } from 'react';
import { Wrench, ArrowLeft, ArrowRight, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ProblemTypeScreen = () => {
  const [selectedProblem, setSelectedProblem] = useState('');
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const navigate = useNavigate();

  const problems = [
    { id: 'flat', label: 'Pană de cauciuc' },
    { id: 'pressure', label: 'Presiune scăzută' },
    { id: 'damage', label: 'Deteriorare vizibilă' },
    { id: 'other', label: 'Altă problemă' }
  ];

  const handleClose = () => {
    setShowConfirmDialog(true);
  };

  const handleConfirmClose = () => {
    navigate('/');
  };

  const handleNext = () => {
    navigate('/additional-details');
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Progress Bar */}
      <div className="h-1 bg-blue-600 w-2/3" />

      {/* Header with Back and Close buttons */}
      <div className="p-4 flex justify-between items-center">
        <button onClick={() => navigate(-1)} className="p-2">
          <ArrowLeft className="w-6 h-6 text-gray-600" />
        </button>
        <button onClick={handleClose} className="p-2">
          <X className="w-6 h-6 text-gray-600" />
        </button>
      </div>

      {/* Content */}
      <div className="px-4 pb-24">
        <div className="max-w-md mx-auto">
          {/* Icon and Title */}
          <div className="mb-8">
            <Wrench className="w-16 h-16 text-blue-600 mb-4" />
            <h1 className="text-2xl font-bold text-gray-800">
              Ce problemă ai întâmpinat?
            </h1>
          </div>

          {/* Problem Type Selection */}
          <div className="space-y-3">
            {problems.map((problem) => (
              <button
                key={problem.id}
                onClick={() => setSelectedProblem(problem.id)}
                className={`w-full p-4 rounded-xl text-left transition-colors ${
                  selectedProblem === problem.id
                    ? 'bg-blue-600 text-white'
                    : 'bg-gray-50 text-gray-800 hover:bg-gray-100'
                }`}
              >
                {problem.label}
              </button>
            ))}
          </div>

          {selectedProblem === 'other' && (
            <div className="mt-4">
              <textarea
                className="w-full p-4 bg-gray-50 rounded-xl h-32 resize-none"
                placeholder="Descrie problema ta..."
              />
            </div>
          )}
        </div>
      </div>

      {/* Continue Button - Fixed at bottom */}
      <div className="fixed bottom-0 left-0 right-0 p-4 bg-white border-t">
        <div className="max-w-md mx-auto">
          <button
            onClick={handleNext}
            disabled={!selectedProblem}
            className={`w-full p-4 rounded-xl font-medium flex items-center justify-center ${
              selectedProblem
                ? 'bg-blue-600 text-white hover:bg-blue-700'
                : 'bg-gray-200 text-gray-400 cursor-not-allowed'
            }`}
          >
            Continuă
            <ArrowRight className="ml-2 w-5 h-5" />
          </button>
        </div>
      </div>

      {/* Confirmation Dialog */}
      {showConfirmDialog && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl p-6 max-w-sm w-full">
            <h3 className="text-xl font-semibold text-gray-900 mb-4">
              Ești sigur că vrei să renunți?
            </h3>
            <p className="text-gray-600 mb-6">
              Dacă închizi acum, vei pierde toate informațiile introduse.
            </p>
            <div className="flex gap-4">
              <button
                onClick={() => setShowConfirmDialog(false)}
                className="flex-1 py-3 px-4 rounded-xl bg-gray-100 text-gray-700 font-medium"
              >
                Nu, rămân
              </button>
              <button
                onClick={handleConfirmClose}
                className="flex-1 py-3 px-4 rounded-xl bg-red-600 text-white font-medium"
              >
                Da, renunț
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProblemTypeScreen;